:host {
  display: block;
  cursor: pointer;
  .icon {
    display: inline-block;
    line-height: 0;
  }
  .main-container {
    transition: background-color 0.25s;
    position: relative;
    &:hover {
      background-color: var(--item-hover-color);
    }
  }
  .text {
    color: var(--text-color);
  }
}
:host(.collapsable) {
  overflow: hidden;
}
:host(.item--active) {
  .main-container {
    background-color: var(--item-active-color);
  }
}
//LIST ITEM
:host(.item) {
  .main-container:active {
    background-color: var(--item-active-color);
  }
}
//uncollapsed
:host(.uncollapsed) {
}
// LIST ONE
:host(.list-one__item) {
  .main-container {
    display: flex;
    justify-content: space-between;
    padding: var(--first-list-text-vertical-padding) 8px
      var(--first-list-text-vertical-padding) 16px;
    min-height: 40px;
    box-sizing: border-box;
    align-items: start;

    .left-container {
      display: flex;
      align-items: start;
      padding-inline-end: 8px;
      .custom-icon {
        margin-inline-end: 8px;
      }

      .text {
        font-size: var(--first-list-font-size);
        text-transform: var(--first-list-text-transform);
        line-height: var(--first-list-line-height);
      }
    }
    .arrow-icon {
      transform: rotate(180deg);
      transition: transform 0.25s;
    }
  }
}
:host(.list-one__item.uncollapsed) {
  .arrow-icon {
    transform: rotate(0);
  }
}
:host(.list-one__item.speed-zero) {
  transition-duration: 0.01s !important;
}
:host(.switch-order) {
  .main-container {
    flex-direction: row-reverse;
  }
  .left-container {
    flex-direction: row-reverse;
    padding-inline-end: 0 !important;
  }
  .text {
    opacity: 0;
  }
  .custom-icon {
    margin-inline-end: 0 !important;
  }
}
// LIST TWO
:host(.list-two__item) {
  .main-container {
    display: flex;
    align-items: self-start;
    padding-inline-start: 44px;
    padding-top: var(--second-list-text-vertical-padding);
    padding-bottom: var(--second-list-text-vertical-padding);
    min-height: 20px;
    .arrow-icon {
      transform: rotate(0);
      transition: transform 0.25s;
      margin-inline-end: 4px;
    }
    .text {
      font-size: var(--second-list-font-size);
      font-weight: 700;
      letter-spacing: 0.027em;
      text-transform: var(--second-list-text-transform);
      line-height: var(--second-list-line-height);
    }
  }
}
:host(.list-two__item:not(.collapsable)) {
  .main-container {
    padding-inline-start: 51px;
  }
}
:host(.list-two__item.uncollapsed) {
  .arrow-icon {
    transform: rotate(90deg);
  }
}
// LIST THREE
:host(.list-three__item) {
  .main-container {
    padding-inline-start: 73px;
    padding-top: var(--third-list-text-vertical-padding);
    padding-bottom: var(--third-list-text-vertical-padding);

    .text {
      font-size: var(--third-list-font-size);
      text-transform: var(--third-list-text-transform);
      line-height: var(--third-list-line-height);
    }
  }
}
